import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ProgressBar from '../../../../components/progress-bar';
import { fetchAllFilters } from '../../FilterActions';
import { getLoading, getLoaded, getHasErrors, getErrors } from '../../FilterReducer';
import FilterDetailPage from './FilterDetailPage';
import FilterIndexPage from './FilterIndexPage';

class FilterPage extends Component {
  componentDidMount() {
    this.syncFilters();
  }

  syncFilters() {
    this.props.dispatch(fetchAllFilters());
  }

  render() {
    const {
      loading, loaded, hasErrors, errors,
    } = this.props;
    return (
      <div className="container">
        <Helmet title="Manage Filters" />
        {loading && <div><p /><ProgressBar /></div>}
        {hasErrors && <div className="alert alert-danger">{errors.message}</div>}
        {loaded && <Switch>
          <Route exact path="/setup/filters" component={FilterIndexPage} />
          <Route path="/setup/filters/:filterID" component={FilterDetailPage} />
        </Switch>}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getLoading(state),
    loaded: getLoaded(state),
    hasErrors: getHasErrors(state),
    errors: getErrors(state),
  };
}

FilterPage.propTypes = {
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

FilterPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(FilterPage));
